<div class="no-itens" *ngIf="_itensCart?.length === 0">
  Nenhum produto adicionado ao seu carrinho!
</div>
<div class="cart-products" *ngIf="(_itensCart?.length || 0) > 0">
  <div class="checkout-popup-title">Produtos adicionados ao carrinho</div>
  <div class="product-checkout-list">
    <a
      class="product-checkout-popup"
      href="{{ item?.product?.url || item?.product?.url }}"
      (click)="
        onClickOpenProduct(item?.product?.url || '');
        $event.stopPropagation();
        $event.preventDefault()
      "
      *ngFor="let item of _itensCart"
    >
      <figure>
        <img
          [src]="
            item?.product?.mainPhotoS3Url ||
            item?.product?.photos?.slice()?.shift()?.url ||
            ''
          "
          [alt]="item?.product?.name"
        />
      </figure>
      <div class="product-checkout-popup-inf">
        <span
          >{{ item?.product?.name
          }}{{
            item?.product?.productPerSquareMeter
              ? " - (" +
                item?.customWidth?.toFixed(2) +
                " m x " +
                item?.customHeight?.toFixed(2) +
                " m)"
              : ""
          }}

          <span
            *ngIf="
              item?.product?.isPersiana() && !item?.product?.isProntaEntrega()
            "
          >
            - {{ item?.controlSideDescription }}

            {{
              !item?.product?.isPersianaHorizontal()
                ? " - " + item?.driveDescription
                : ""
            }}

            {{
              !item?.product?.isPersianaRomana() &&
              !item?.product?.isPersianaHorizontal()
                ? " - " + item?.panelDescription
                : ""
            }}</span
          ></span
        >

        <span>Quantidade: ({{ item?.amount }})</span>
        <span *ngIf="!item?.product?.discount">
          <b>{{ getValueItem(item, false) | customCurrencyLight }}</b></span
        >
        <span *ngIf="item?.product?.discount || 0 > 0"
          ><del>{{
            getValueItem(item, false) * (item?.amount || 1)
              | customCurrencyLight
          }}</del
          ><b> por </b>
          <b>{{
            getValueItem(item, true) * (item?.amount || 1) | customCurrencyLight
          }}</b></span
        >
      </div>
    </a>
  </div>
  <span class="total-price-cart"
    ><span>Subtotal: {{ cart.valueSubtotal | customCurrencyLight }}</span>
    <span *ngIf="cart.haveProductDiscount"
      >Desconto: -{{ cart.valueDiscount | customCurrencyLight }}</span
    ><span>Total: {{ cart.valueTotal || 0 | customCurrencyLight }}</span></span
  >
  <div class="footer-button">
    <a routerLink="/pagamento">
      <button
        title="Acessar seu carrinho para finalizar sua compra"
        aria-label="Acessar seu carrinho para finalizar sua compra"
        class="button-rm button-rm-green"
      >
        FINALIZAR SUA COMPRA
      </button>
    </a>
    <a routerLink="/carrinho">
      <button
        title="Acessar seu carrinho"
        aria-label="Acessar seu carrinho"
        class="button-rm button-rm-white"
      >
        ACESSAR SEU CARRINHO
      </button>
    </a>
  </div>
</div>
